var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    rx: 17,
    fill: "#CFEEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4463 10.1026C23.6307 10.0118 23.8325 9.98042 24.0308 10.0119C24.2291 10.0433 24.4166 10.1364 24.5737 10.2814C24.7308 10.4265 24.8519 10.6182 24.9242 10.8365C24.9966 11.0549 25.0176 11.292 24.9852 11.5231L23.2925 23.5415C23.1283 24.7008 22.0417 25.3656 21.1334 24.7881C20.3737 24.305 19.2453 23.5607 18.2303 22.7841C17.7228 22.3953 16.1682 21.1504 16.3593 20.2645C16.5234 19.5071 19.1355 16.6609 20.6282 14.9687C21.214 14.3038 20.9469 13.9203 20.255 14.5319C18.5363 16.0502 15.7786 18.3592 14.8666 19.0092C14.0621 19.5823 13.6427 19.6801 13.1412 19.5823C12.2262 19.404 11.3776 19.128 10.685 18.7916C9.74915 18.3373 9.79468 16.8312 10.6843 16.3927L23.4463 10.1026Z",
    fill: "#0FA958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentSms);
export default __webpack_public_path__ + "static/media/sentSms.1ad5a74b3662e938c4d7075c8a9ffd39.svg";
export { ForwardRef as ReactComponent };